<div class="container-fluid">

  <h4 id="upper">Membres </h4>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">

          <div class="row mb-md-2">
            <div class="d-flex align-items-center gap-3 flex-wrap">
              <!-- Champ de recherche -->
              <label for="categorie" class="form-label">Rechercher</label>
              <div>
                <label class="d-inline-flex align-items-center">
                  <input type="text" [(ngModel)]="searchTerm" (input)="searchMembres()" class="form-control"
                    id="searchMembre" placeholder="Nom du membre" />

                </label>
              </div>

              <label for="categorie" class="form-label">Coopérative</label>
              <div>
                <label class="d-inline-flex align-items-center">
                  <select [(ngModel)]="selectedCooperative" (change)="filterMembres()" name="statut" class="form-select"
                    id="categorie">
                    <option value="">Toutes les coopératives</option>
                    <option *ngFor="let item of cooperativeItems" [value]="item.id">{{ item.nom }}</option>
                  </select>
                </label>
              </div>

              <!-- Bouton de recherche -->
              <div class="d-inline-flex align-items-center">

              </div>
            </div>

          </div>
          <div class="table-responsive">
            <table class="table text-nowrap align-middle mb-0">
              <thead>
                <tr class="border-2 border-bottom border-primary border-0 custom-border-bottom-medecin"
                  style="border-color: #578D63;">
                  <th scope="col" class="ps-0">Membres</th>
                  <th scope="col" class="text-center">Date adhésion</th>
                  <th scope="col" class="text-center">Coopérative</th>
                  <th scope="col" colspan="2" class="text-center">Action</th>
                </tr>
              </thead>
              <tbody class="table-group-divider">
                <tr *ngFor="let item of paginatedItems">
                  <th scope="row" class="ps-0 fw-medium">
                    <span class="table-link1 text-truncate d-block"> {{item.nom }} {{item.prenom}} &nbsp;
                    </span>
                  </th>

                  <td class="text-center fw-medium">
                    <span class="table-link1 text-truncate d-block">{{item?.date_adhesion | dateFormat}}</span>
                  </td>
                  <td class="text-center fw-medium">
                    <span class="table-link1 text-truncate d-block">{{item?.cooperative?.nom}} &nbsp;</span>
                  </td>
                  <td class="text-center fw-medium">
                    <a (click)="openModal(item)" title="" style="cursor: pointer;" class="me-3 text-primary"
                      v-b-tooltip.hover title="Cliquez ici pour voir plus de détails">
                      Détails &nbsp;&nbsp; <i class="ri-eye-fill font-size-18"></i>
                    </a>

                  </td>

                </tr>
              </tbody>
            </table>
          </div>

        </div>
        <div class="d-flex justify-content-center mt-4" *ngIf="isLoading === true">
          <div class="container">
            <div class="row">
              <div class="text-center">
                <h5 id="graycolor">Chargement en cours...</h5>
                <div class="loader4"></div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="hasError && !isLoading" class="text-center my-5">
          <i class="bi bi-exclamation-circle text-danger" style="font-size: 2rem;"></i>
          <p class="text-danger">{{ errorMessage }}</p>
          <button class="btn btn-primary" (click)="getMembres()"><i class="pi pi-refresh" style="font-size: 2rem"></i>
          </button>
        </div>

        <div *ngIf="paginatedItems.length === 0 && isLoading === false" class="d-flex justify-content-center mt-4">
          <div class="container">
            <div class="row">
              <div class="text-center">
                <h5 id="graycolor">Aucune donnée trouvée</h5>
              </div>
            </div>
          </div>

        </div>
        <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords"
          [rowsPerPageOptions]="[10, 20, 30]">
        </p-paginator>
      </div>
    </div>
  </div>


</div>
<ng-template #modalContent1 let-modal>
  <div class="modal-body">
    <div class="container">
      <!-- Informations du Membre -->
      <div class="card mb-4">
        <div class="card-header bg-success text-white">
          <h4 class="text-center">Informations du Membre</h4>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-6"><strong>Nom :</strong> <span class="text-muted">{{ detailsItems.nom }}</span></div>
            <div class="col-6"><strong>Prénom :</strong> <span class="text-muted">{{ detailsItems.prenom }}</span></div>
          </div>
          <div class="row">
            <div class="col-6"><strong>Date de Naissance :</strong> <span class="text-muted">{{
                detailsItems.date_naissance | date: 'dd MMM yyyy' }}</span></div>
            <div class="col-6"><strong>Téléphone :</strong> <span class="text-muted">{{ detailsItems.telephone }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-6"><strong>Email :</strong> <span class="text-muted">{{ detailsItems.email }}</span></div>
            <div class="col-6"><strong>Sexe :</strong> <span class="text-muted">{{ detailsItems.sexe }}</span></div>
          </div>
          <div class="row">
            <div class="col-6"><strong>Statut :</strong> <span class="badge bg-warning text-dark">{{ detailsItems.statut
                | titlecase }}</span></div>
            <div class="col-6"><strong>Référence :</strong> <span class="text-muted">{{ detailsItems.reference }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Informations de la Coopérative -->
      <div class="card mb-4">
        <div class="card-header bg-warning text-dark">
          <h4 class="text-center">Informations de la Coopérative</h4>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-6"><strong>Nom :</strong> <span class="text-muted">{{ detailsItems.cooperative.nom }}</span>
            </div>
            <div class="col-6"><strong>Localisation :</strong> <span class="text-muted">{{
                detailsItems.cooperative.localisation }}</span></div>
          </div>
          <div class="row">
            <div class="col-12"><strong>Description :</strong> <span class="text-muted">{{
                detailsItems.cooperative.description }}</span></div>
          </div>
        </div>
      </div>

      <!-- Informations sur la Ville -->
      <div class="card mb-4">
        <div class="card-header bg-info text-white">
          <h4 class="text-center">Informations sur la Ville</h4>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-6"><strong>Nom de la ville :</strong> <span class="text-muted">{{ detailsItems.ville.name
                }}</span></div>
            <div class="col-6"><strong>Pays :</strong> <span class="text-muted">{{ detailsItems.ville.country.name
                }}</span></div>
          </div>
          <div class="row">
            <div class="col-6"><strong>Code Pays :</strong> <span class="text-muted">{{ detailsItems.ville.country.iso2
                }}</span></div>
            <div class="col-6"><strong>Région :</strong> <span class="text-muted">{{ detailsItems.ville.country.region
                }}</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Close click')">Fermer</button>
  </div>
</ng-template>


<p-toast />
<p-confirmDialog />
<ngx-ui-loader></ngx-ui-loader>